import { render } from "./d-icon.vue?vue&type=template&id=39688402&scoped=true"
import script from "./d-icon.vue?vue&type=script&lang=js"
export * from "./d-icon.vue?vue&type=script&lang=js"

import "./d-icon.vue?vue&type=style&index=0&id=39688402&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39688402"]])

export default __exports__